<!-- <div class="explorer-demo-container">
      
      <div class="explorer-wrapper">

        <div class="image-viewer-container"> -->

  <!-- Image display area -->
  <!-- <div class="viewer-content"> -->
    <!-- Loading state with Shimmer -->
    @if (isLoading() && !hasError()) {
      <!-- <app-document-loader
        message="Loading image..."
        [variant]="ShimmerVariant.Card"
        loaderId="image-loader"
      /> -->
            <div class="loader-overlay">
      <optima-progress-indicator
        [view]="ProcessProgressView.Shimmer"
        [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
          { width: '100%', height: '100%' }
        ] } }">
      </optima-progress-indicator>
    </div>
    }

    <!-- Error state -->
    @if (hasError()) {
      <div class="error-state">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <h2>Failed to Load Image</h2>
        <p>{{ errorMessage() }}</p>
        <button class="retry-btn" (click)="closeViewer()">Back to Libraries</button>
      </div>
    }

    <!-- Image -->
    @if (!hasError() && imageUrl()) {
      <!-- <div [class.loaded]="!isLoading()"> -->
        <img 
        width="100%"
        height="100%"
          [src]="imageUrl()" 
          [alt]="imageName()"
          (load)="onImageLoad()"
          (error)="onImageError($event)"
        />
      <!-- </div> -->
    }
  <!-- </div> -->
<!-- </div>
      </div>
    </div> -->